import { createContext, useContext } from 'react';

export const ScrollContext = createContext<any>({});
export const useScrolls = () => useContext(ScrollContext);
